import { usingGet } from '@ocean/api'
import { UserUtils } from 'utils'

export const getCesDetails = (cesId: Guid, resultId?: Guid) => {
  const baseUrl = `crewEvaluation/details/${cesId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}

export const getCesLockout = (activityId: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingGet(
    `Requirements/GetCrewEvaluationRequirementLockout?activityId=${activityId}&userId=${userId}`
  )
}
